import * as React from 'react'

import { StepLabel, StepStyle, StepWrapper } from '../styles'

export interface StepProps {
  label: string
  icon?: React.ReactElement | number
  isIncomplete: boolean
}

export const Step = (props: StepProps) => {
  return (
    <StepWrapper>
      <StepLabel isIncomplete={props.isIncomplete}>{props.label}</StepLabel>
      <StepStyle isIncomplete={props.isIncomplete}>{props.icon}</StepStyle>
    </StepWrapper>
  )
}
